export interface LangCode {
  code: string;
  originalLabel?: string;
  label: string;
  rtl: boolean;
}

export const DEFAULT_LANG_CODE = 'en';

export const LangCodeMap = [
  { code: 'en', label: 'English', rtl: false, originalLabel: '🇬🇧 English' },
  { code: 'af', label: 'Afrikaans', rtl: false },
  { code: 'ar', label: 'Arabic', rtl: true, originalLabel: '🇦🇪 عربى' },
  { code: 'ar-sa', label: 'Arabic (Saudi Arabia)', rtl: true, originalLabel: '🇸🇦 عربي سعودي' },
  { code: 'bn', label: 'Bengali', rtl: false, originalLabel: '🇧🇩 বাংলা' },
  { code: 'bg', label: 'Bulgarian', rtl: false, originalLabel: '🇧🇬 български' },
  { code: 'zh-Hans', label: 'Chinese (simplified)', rtl: false, originalLabel: '🇨🇳 中文（简体)' },
  { code: 'zh-Hant', label: 'Chinese (traditional)', rtl: false, originalLabel: '🇨🇳 中文（繁體)' },
  { code: 'cs', label: 'Czech', rtl: false, originalLabel: '🇨🇿 Čeština' },
  { code: 'da', label: 'Danish', rtl: false, originalLabel: '🇩🇰 Dansk' },
  { code: 'de', label: 'German', rtl: false, originalLabel: '🇩🇪 Deutsch' },
  { code: 'fi', label: 'Finnish', rtl: false, originalLabel: '🇫🇮 Suomi' },
  { code: 'hu', label: 'Hungarian', rtl: false, originalLabel: '🇭🇺 Magyar' },
  { code: 'it', label: 'Italian', rtl: false, originalLabel: '🇮🇹 Italiano' },
  { code: 'nl', label: 'Dutch', rtl: false, originalLabel: '🇳🇱 Nederlands' },
  { code: 'pl', label: 'Polish', rtl: false, originalLabel: '🇵🇱 Polski' },
  { code: 'sv', label: 'Swedish', rtl: false, originalLabel: '🇸🇪 Svenska' },
  { code: 'tr', label: 'Turkish', rtl: false, originalLabel: '🇹🇷 Türkçe' },
  { code: 'sk', label: 'Slovak', rtl: false, originalLabel: '🇸🇰 Slovenčina' },
  { code: 'fil', label: 'Filipino', rtl: false },
  { code: 'fr', label: 'French', rtl: false, originalLabel: '🇫🇷 Français' },
  { code: 'fr-ca', label: 'French (Canada)', rtl: false, originalLabel: '🇨🇦 Français (Canada)' },
  { code: 'gu', label: 'Gujarati', rtl: false },
  { code: 'he', label: 'Hebrew', rtl: true, originalLabel: '🇮🇱 עִבְרִית' },
  { code: 'hi', label: 'Hindi', rtl: false, originalLabel: '🇮🇳 हिन्दी' },
  { code: 'id', label: 'Indonesian', rtl: false, originalLabel: '🇮🇩 Bahasa Indonesia' },
  { code: 'ja', label: 'Japanese', rtl: false, originalLabel: '🇯🇵 日本語' },
  { code: 'kn', label: 'Kannada', rtl: false },
  { code: 'ko', label: 'Korean', rtl: false, originalLabel: '🇰🇷 한국어' },
  { code: 'ms', label: 'Malay', rtl: false },
  { code: 'ml', label: 'Malayalam', rtl: false },
  { code: 'mi', label: 'Maori', rtl: false },
  { code: 'mr', label: 'Marathi', rtl: false },
  { code: 'ne', label: 'Nepali', rtl: false },
  { code: 'no', label: 'Norwegian', rtl: false, originalLabel: '🇳🇴 Norsk' },
  { code: 'pa', label: 'Panjabi', rtl: false },
  { code: 'pt', label: 'Portuguese', rtl: false, originalLabel: '🇵🇹 Português' },
  { code: 'ru', label: 'Russian', rtl: false, originalLabel: '🇷🇺 Русский язык' },
  { code: 'sr', label: 'Serbian', rtl: false },
  { code: 'es', label: 'Spanish', rtl: false, originalLabel: '🇪🇸 Español' },
  { code: 'sw', label: 'Swahili', rtl: false },
  { code: 'tl', label: 'Tagalog', rtl: false },
  { code: 'ta', label: 'Tamil', rtl: false },
  { code: 'th', label: 'Thai', rtl: false, originalLabel: '🇹🇭 คำเมือง' },
  { code: 'uk', label: 'Ukrainian', rtl: false, originalLabel: '🇺🇦 українська мова' },
  { code: 'ur', label: 'Urdu', rtl: true, originalLabel: '🇵🇰 اردو' },
  { code: 'vi', label: 'Vietnamese', rtl: false, originalLabel: '🇻🇳 Tiếng Việt' },
];
